import React, {useState} from 'react'
import {Grid, Typography, Fab, Button, Link,
    CircularProgress, Box} from '@mui/material'
import MicIcon from "@mui/icons-material/Mic"
import MicNoneIcon from '@mui/icons-material/MicNone'
import { connect } from 'react-redux'
import {nextTask} from '../study-logic/study-redux-slice'
import {ButtonContainer, PageContainer} from "../survey-tools/ui-components/containers"
import fscreen from "fscreen"



const microsoftHelpUrl = 'https://support.microsoft.com/help/4027981/windows-' +
    'how-to-set-up-and-test-microphones-in-windows-10'
const appleHelpUrl = 'https://support.apple.com/kb/PH22070'
const chromeHelpUrl = 'https://support.google.com/chrome/answer/2693767'
const safariHelpUrl = 'https://support.apple.com/guide/safari/websites-' +
    'ibrwe2159f50/mac'
const edgeHelpUrl = 'https://support.microsoft.com/en-us/help/4468232/windows-' +
    '10-camera-microphone-and-privacy'
const firefoxHelpUrl = 'https://support.mozilla.org/en-US/kb/how-manage-your-' +
    'camera-and-microphone-permissions'


function MicCheck(props) {
    const {start, stop, isRecording, blobURL, triedRecording} = props;
    const [currentPage, setCurrentPage] = useState(1); // Added for page tracking
    const buttonAction = isRecording ? stop : start;
    const [noMic, setNoMic] = useState(false);

    const handleNext = () => {
        if (currentPage === 1) {
            setCurrentPage(2); // Go to next page
        } else {
            if (fscreen.fullscreenEnabled && !fscreen.fullscreenElement) {
            fscreen.requestFullscreen(document.documentElement)}

            props.nextTask({ data: { micCheck: "ok" } }); // Original submission logic

        }
    };

    return (
        <PageContainer>
            {currentPage === 1 && (
                <Grid item xs={11} sm={9} md={7} lg={5}>
                    <Typography gutterBottom>
                        In this study, you will need to use your microphone to record
                        audio clips. First, let's make sure your microphone is working.
                    </Typography>
                    <Button onClick={handleNext} variant="contained" color="primary">
                        Next
                    </Button>
                </Grid>
            )}

            {currentPage === 2 && (
                <React.Fragment>
                    <Grid item xs={11} sm={9} md={7} lg={5}>
                        <Typography gutterBottom>
                            Click the button below to start recording. When you do, you may see a
                            message prompting you to allow access to your microphone. Please select
                            "Allow" when this message pops up. Then speak into your microphone for
                            a few seconds and click the button again to stop recording.
                        </Typography>
                    </Grid>

                    <Box sx={{display: "flex", alignItems: "center",
                        position: "relative", flexDirection: "column"}}>
                        <Fab color={isRecording ? 'secondary' : 'primary'}
                             sx={{margin: "6px 0"}}
                             aria-label={'start-recording'}
                             onClick={buttonAction}>
                            {isRecording? <MicNoneIcon /> : <MicIcon />}
                        </Fab>
                        {isRecording && <CircularProgress size={68}
                                                          sx={{
                                                              marginLeft: "-34px",
                                                              left: "50%",
                                                              position: "absolute"
                                                          }}/>}
                    </Box>

                    <Grid item xs={11} sm={9} md={7} lg={5}
                          style={{marginTop: '2em'}}>
                        {blobURL && (
                            <React.Fragment>
                                <Typography gutterBottom>
                                    Below, you can play your recorded audio to make sure your microphone
                                    is working correctly.
                                </Typography>
                                <audio src={blobURL} controls />
                                <Typography gutterBottom style={{marginTop: '2em'}}>
                                    If you were able to hear your test recording, click the "NEXT"
                                    button at the bottom of the page to continue.
                                </Typography>
                            </React.Fragment>
                        )}

                        <ButtonContainer sx={{flexWrap: "wrap",
                            justifyContent: noMic ? "flex-end" : "space-between"}}>
                {(triedRecording && !noMic) &&
                    <Button onClick={() => setNoMic(true)}
                            style={{alignSelf: 'start'}}
                            variant={'outlined'}>
                        The microphone is not working
                    </Button>}

                {noMic && <Box display={"flex"} flexDirection={"column"}
                               sx={{width: "100%"}}>
                    <br />
                    <Typography>
                    <strong>
                        If you don't hear anything, please verify that your audio volume is
                        turned up and your microphone is not muted. You can re-try recording
                        after changing your settings by clicking the microphone button to
                        start and again to stop recording.
                        </strong>
                    </Typography>

                    <br />

                    <Box
        sx={{
            backgroundColor: 'rgba(220, 220, 220, 0.5)', // Custom lighter grey color
            padding: '1em', 
            borderRadius: '8px', 
            marginTop: '1em',
            width: '80%', // Reduced width, you can adjust as needed
        }}
    >
                    <Typography variant={'h5'}>Troubleshooting tips</Typography>

<div style={{ height: '5px' }}></div>                     
                    <Typography gutterBottom>
                        Some headsets and devices have a switch or button that mutes them.
                        Please make sure this switch is off, if you have one.
<div style={{ height: '10px' }}></div> 
                        Then, check your system settings to make sure that your microphone
                        is the default recording device and that the recording levels are
                        correct:
                        <br />
                        <Link onClick={() => window.open(microsoftHelpUrl, '_blank')}>
                            Windows
                        </Link>
                        <br />
                        <Link onClick={() => window.open(appleHelpUrl, '_blank')}>
                            Mac
                        </Link>
                    </Typography>
<div style={{ height: '10px' }}></div> 
                    <Typography gutterBottom>
                        If you didn't get a request to allow the site to access your
                        microphone, or you accidentally selected "Do Not Allow", please
                        change your browser's settings:
                        <br />
                        <Link onClick={() => window.open(chromeHelpUrl, '_blank')}>
                            Google Chrome
                        </Link>
                        <br />
                        <Link onClick={() => window.open(firefoxHelpUrl, '_blank')}>
                            Firefox
                        </Link>
                        <br />
                        <Link onClick={() => window.open(safariHelpUrl, '_blank')}>
                            Safari
                        </Link>
                        <br />
                        <Link onClick={() => window.open(edgeHelpUrl, '_blank')}>
                            Edge
                        </Link>
                    </Typography>
                    </Box>
                </Box>}

                {blobURL &&
                    <Button onClick={handleNext}
                            variant={'contained'}
                            style={{alignSelf: 'end', marginBottom: "1em"}}
                            color={'primary'}>
                        next
                    </Button>
                }                        </ButtonContainer>
                    </Grid>
                </React.Fragment>
            )}
        </PageContainer>
    );
}




const mapDispatchToProps = { nextTask }
export default connect(null, mapDispatchToProps)(MicCheck)

